import { faTrashCan } from "@fortawesome/free-regular-svg-icons";
import { faPenToSquare,faMultiply,faSave, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import ButtonOverride from "../../../../../components/buttonoverride";
import styles from '../../../../../styles/fileupload.module.css';
import { Controller, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import { ReplaceNullsWithEmptyStrings } from "../../../../../utilities/rhfdatanormalizationfunctions";
import useFileDownload from "../../../../../hooks/use-filedownload";

const smallAddButtonStyle = {
    borderRadius: "50%",
    width: "32px",
    height: "32px",
    minWidth: "32px",
    minHeight: "32px",
    padding: 0,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
};

const ViewMode = ({toggleMode,bid,remove,actionTypes = []}) => {
    const actionText = actionTypes.find(item => item.id === bid.action)?.name;
    const bidAmount = bid.amount?.toFixed(2);
    const finalAmount = bid.finalamount?.toFixed(2);
    
    const downloadFile = useFileDownload();
    return(
        <tr>
            <td className="align-middle">
                {
                    bid.bidupload
                    ?
                        bid.bidupload instanceof File
                        ?
                            <a href={URL.createObjectURL(bid.bidupload)} target="_blank" rel="noopener noreferrer" className={styles.addedDoc}>
                                View File
                            </a>
                        :
                            <Button type="button" title="Download File" aria-label="Download File" variant="link" className={styles.addedDoc} onClick={() => downloadFile({FileID: bid.bidupload.id},'DownloadBidInspectionFile',bid.bidupload.name)}>
                                View File
                            </Button>
                    :   
                        <>N/A</>
                }
            </td>
            <td className="align-middle">{bidAmount ? <>${bidAmount}</> : <>N/A</>}</td>
            <td className="align-middle">{actionText}</td>
            <td className="align-middle">
                {
                    bid.checkupload
                    ?
                        bid.checkupload instanceof File
                        ?
                            <a href={URL.createObjectURL(bid.checkupload)} target="_blank" rel="noopener noreferrer" className={styles.addedDoc}>
                                View File
                            </a>
                        :
                            <Button type="button" title="Download File" aria-label="Download File" variant="link" className={styles.addedDoc} onClick={() => downloadFile({FileID: bid.checkupload.id},'DownloadBidInspectionFile',bid.checkupload.name)}>
                                View File
                            </Button>
                    :   
                        <>N/A</>
                }
            </td>
            <td className="align-middle">{finalAmount ? <>${finalAmount}</> : <>N/A</>}</td>
            <td className="align-middle">{bid.comments}</td>
            <td className="align-middle">{bid.lastmodifieddate}</td>
            <td className="align-middle">{bid.lastmodifiedbyuser}</td>
            <td className="align-middle">
                <div className="d-flex justify-content-around">
                        <div>
                            <Button size="sm" type="button" variant="primary" className="me-1" title="Edit Row" aria-label="Edit Row" onClick={toggleMode}>
                                <FontAwesomeIcon icon={faPenToSquare} />
                            </Button>
                        </div>
                        <div>
                            <Button size='sm' type="button" variant="danger" title="Remove Item" aria-label="Remove Item" onClick={() => remove(bid.id)}>
                                <FontAwesomeIcon icon={faTrashCan} />
                            </Button>
                        </div>
                </div>
            </td>
        </tr>
    )

}

const EditMode = ({toggleMode,bid,update,actionTypes = []}) => {
    const bidRef = useRef(null);
    const [bidUpload,setBidUpload] = useState(null);

    const checkRef = useRef(null);
    const [checkUpload,setCheckUpload] = useState(null);

    const _handleBidFileClick = () => {
        if(bidRef?.current){
            bidRef.current.click();
        }
    }

    const _handleBidFileChange = (e) => {
        setBidUpload(e.target.files[0]);

        bidRef.current.value = '';
    }

    const _handleCheckFileClick = () => {
        if(checkRef?.current){
            checkRef.current.click();
        }
    }

    const _handleCheckFileChange = (e) => {
        setCheckUpload(e.target.files[0]);

        checkRef.current.value = '';
    }


    const {handleSubmit,register,control,reset} = useForm();

    const _handleSubmit = (values) => {
        const updateVals = {
            action: values[`action${bid.id}`],
            amount: values[`bidamount${bid.id}`],
            bidupload: bidUpload,
            checkupload: checkUpload,
            comments: values[`comment${bid.id}`],
            finalamount: values[`finalamount${bid.id}`],
            id: bid.id,
            lastmodifiedby: bid.lastmodifiedby,
            lastmodifieddate: bid.lastmodifieddate
        } 

        update(bid.id,updateVals);

        toggleMode();
    }

    useEffect(() => {
        const {id,checkupload,bidupload,lastmodifieddate,lastmodifiedby,...rest} = bid;

        const resetVal = {};
        resetVal[`action${id}`] = rest.action;
        resetVal[`bidamount${id}`] = rest.amount;
        resetVal[`comment${id}`] = rest.comments;
        resetVal[`finalamount${id}`] = rest.finalamount;

        setBidUpload(bidupload);
        setCheckUpload(checkupload);
        reset(ReplaceNullsWithEmptyStrings(resetVal));
    },[])

    const downloadFile = useFileDownload();

    return(
        <tr>
            <td className="align-middle">
                {
                        bidUpload
                        ?
                            bidUpload instanceof File
                            ?
                                <div className='d-flex align-items-center'>
                                    <a href={URL.createObjectURL(bidUpload)} target="_blank" rel="noopener noreferrer" className={styles.addedDoc}>
                                        View File
                                    </a>
                                    <ButtonOverride type="button" className={`${styles.deleteAddedButton} ms-2`} aria-label="Remove Document" title="Remove Document" onClick={() => setBidUpload(null)}>
                                        <FontAwesomeIcon icon={faMultiply} size="lg" style={{color: 'red'}}/>
                                    </ButtonOverride>
                                </div>
                            :
                                <div className='d-flex align-items-center'>
                                    <Button type="button" title="Download File" aria-label="Download File" variant="link" className={styles.addedDoc} onClick={() => downloadFile({FileID: bidUpload.id},'DownloadBidInspectionFile',bidUpload.name)}>
                                        View File
                                    </Button>
                                    <ButtonOverride type="button" className={`${styles.deleteAddedButton} ms-2`} aria-label="Remove Document" title="Remove Document" onClick={() => setBidUpload(null)}>
                                        <FontAwesomeIcon icon={faMultiply} size="lg" style={{color: 'red'}}/>
                                    </ButtonOverride>
                                </div>
                        :
                            <Button id="bidupload" type="button" variant="success" onClick={_handleBidFileClick} aria-label="Add Document(s)" title="Add Document(s)" className={`ms-1 ${styles.addFileButtonZ} ${styles.smallz}`} style={smallAddButtonStyle}>
                                <FontAwesomeIcon icon={faPlus} />
                            </Button>
                }
                <input ref={bidRef} type="file" style={{display: 'none'}} multiple={false} onChange={_handleBidFileChange}/>
            </td>
            <td className="align-middle">
                <Controller
                    name={`bidamount${bid.id}`}
                    control={control}
                    render={({ field }) => (
                        <NumericFormat 
                            value={field.value} 
                            id={`bidamount${bid.id}`}
                            placeholder="Bid Amount" 
                            style={{ width: '100%', height: '32px' }} 
                            prefix={'$'} 
                            decimalScale={2} 
                            fixedDecimalScale={true} 
                            allowNegative={false}
                            onValueChange={(values) => {
                                if(values.floatValue === undefined || values.floatValue === null){
                                    field.onChange(null); //Reset to default
                                }
                                else{
                                    field.onChange(values.floatValue);
                                }
                            }} 
                        />
                    )}
                />
            </td>
            <td className="align-middle">
                {
                    actionTypes.map((item) => (
                        <label key={item.id} className="d-block">
                            <input type="radio" {...register(`action${bid.id}`)} value={item.id} />
                            {item.name}
                        </label>
                    ))
                }
            </td>
            <td className="align-middle">
                {
                        checkUpload
                        ?
                            checkUpload instanceof File
                            ?
                                <div className='d-flex align-items-center'>
                                    <a href={URL.createObjectURL(checkUpload)} target="_blank" rel="noopener noreferrer" className={styles.addedDoc}>
                                        View File
                                    </a>
                                    <ButtonOverride type="button" className={`${styles.deleteAddedButton} ms-2`} aria-label="Remove Document" title="Remove Document" onClick={() => setCheckUpload(null)}>
                                        <FontAwesomeIcon icon={faMultiply} size="lg" style={{color: 'red'}}/>
                                    </ButtonOverride>
                                </div>
                            :
                                <div className='d-flex align-items-center'>
                                    <Button type="button" title="Download File" aria-label="Download File" variant="link" className={styles.addedDoc} onClick={() => downloadFile({FileID: checkUpload.id},'DownloadBidInspectionFile',checkUpload.name)}>
                                        View File
                                    </Button>
                                    <ButtonOverride type="button" className={`${styles.deleteAddedButton} ms-2`} aria-label="Remove Document" title="Remove Document" onClick={() => setCheckUpload(null)}>
                                        <FontAwesomeIcon icon={faMultiply} size="lg" style={{color: 'red'}}/>
                                    </ButtonOverride>
                                </div>
                        :
                            <Button id="bidupload" type="button" variant="success" onClick={_handleCheckFileClick} aria-label="Add Document(s)" title="Add Document(s)" className={`ms-1 ${styles.addFileButtonZ} ${styles.smallz}`} style={smallAddButtonStyle}>
                                <FontAwesomeIcon icon={faPlus} />
                            </Button>
                }
                <input ref={checkRef} type="file" style={{display: 'none'}} multiple={false} onChange={_handleCheckFileChange}/>
            </td>
            <td className="align-middle">
                <Controller
                    name={`finalamount${bid.id}`}
                    control={control}
                    render={({ field }) => (
                        <NumericFormat 
                            value={field.value} 
                            id={`finalamount${bid.id}`}
                            placeholder="Final Amount" 
                            style={{ width: '100%', height: '32px' }} 
                            prefix={'$'} 
                            decimalScale={2} 
                            fixedDecimalScale={true} 
                            allowNegative={false}
                            onValueChange={(values) => {
                                if(values.floatValue === undefined || values.floatValue === null){
                                    field.onChange(null); //Reset to default
                                }
                                else{
                                    field.onChange(values.floatValue);
                                }
                            }} 
                        />
                    )}
                />
            </td>
            <td className="align-middle">
                <textarea rows={2} placeholder="Comments" {...register(`comment${bid.id}`)} />
            </td>
            <td className="align-middle">{bid.lastmodifieddate}</td>
            <td className="align-middle">{bid.lastmodifiedby}</td>
            <td className="align-middle">
                <div className="d-flex align-items-center">
                    <ButtonOverride type="button" className='me-2 p-0' title="Save Changes" aria-label="Save Changes" onClick={handleSubmit(_handleSubmit)}>
                        <FontAwesomeIcon icon={faSave} size="lg" style={{ color: '#0d6efd' }} />
                    </ButtonOverride>
                    <ButtonOverride type="button" className='ms-2 p-0' title="Cancel Changes" aria-label="Cancel Changes" onClick={toggleMode}>
                        <FontAwesomeIcon icon={faMultiply} size="lg" />
                    </ButtonOverride>
                </div>
            </td>
        </tr>
    )

}

const BidItem = ({bid,actionTypes = [],update,remove}) => {
    const [editMode,setEditMode] = useState(false);

    const _toggleMode = () => setEditMode(!editMode);

    return(
        <>
            {
                editMode
                ?
                    <EditMode
                        toggleMode={_toggleMode}
                        actionTypes={actionTypes}
                        bid={bid}
                        update={update}
                    />
                :
                    <ViewMode
                        toggleMode={_toggleMode}
                        bid={bid}
                        actionTypes={actionTypes}
                        remove={remove}
                    />
            }
        </>
    )
}

export default BidItem;
